import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Modal2
import { Dialog, Header } from "core/Dialog";

// Context
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout/QueueContext";

// Hooks
import { useLargeImageView } from "frontend/components/fort/mod/photos/hooks/useLargeImageView";

import { convertPxToRem } from "frontend/components/helpers";

const Lightbox = styled(Dialog)`
    width: calc(100% - 268px);
    height: calc(100% - 68px);
    left: 0px;
    right: 268px;
    top: 68px;
    bottom: 0px;
    margin: 0;
`;

const LightboxContent = styled.div`
    flex: 1;
    overflow: auto;
    padding: ${convertPxToRem(24)};
`;

const ExpandedModal = ({ title, children }) => {
    const { state } = useQueueContext();
    const { isLargeImageViewVisible } = state;
    const { closeLargeView } = useLargeImageView();

    const handleClose = () => {
        closeLargeView();
    };

    return (
        <Lightbox
            isVisible={isLargeImageViewVisible}
            isModal={false}
            onClose={handleClose}
            zIndex={501}
        >
            <Header title={title} onClose={handleClose} />
            <LightboxContent>{children}</LightboxContent>
        </Lightbox>
    );
};

export default ExpandedModal;

// prop-types
ExpandedModal.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
};
